module.exports = __webpack_public_path__ + "img/avnon-3.24b3e1a8.webp";